import { Banner, Text } from '@betterment/samba-react';

import { SambaAutoLink } from '~/b4b/components/SambaAutoLink';
import { useCurrentEmployerId } from '~/b4b/utils/currentEmployer';
import { urlBuilder } from '~/b4b/utils/urlBuilder';
import { BenefitReportStatus } from '~/graphql/schema';

import { useNotifications, useReportStatusPolling } from './hooks';

export const isReportPending = (status: BenefitReportStatus) => status === BenefitReportStatus.Pending;

export const isReportComplete = (status: BenefitReportStatus) => status === BenefitReportStatus.Complete;

export const Notifications = () => {
  const { notifications, dequeueNotification, dismissNotification, updateNotificationStatus } = useNotifications();

  useReportStatusPolling(notifications, updateNotificationStatus, useCurrentEmployerId());

  return (
    <>
      {notifications.map(
        notification =>
          (isReportComplete(notification.status) || !notification.dismissed) && (
            <Banner
              key={notification.reportId}
              variant={isReportPending(notification.status) ? 'info' : 'success'}
              css={{ marginBottom: 'space.200' }}
            >
              <Banner.Content>
                <Text as="p">
                  {isReportPending(notification.status) &&
                    `Your ${notification.reportName} report is still generating. This could take a few minutes.`}
                  {isReportComplete(notification.status) && (
                    <>
                      Your {notification.reportName} report was generated.{' '}
                      <SambaAutoLink
                        to={urlBuilder.getReportCsvDownload(notification.reportId)}
                        download={notification.reportFilename}
                      >
                        Download report
                      </SambaAutoLink>
                    </>
                  )}
                </Text>
              </Banner.Content>
              {notification.status === BenefitReportStatus.Complete && (
                <Banner.Close
                  onClick={() => {
                    dequeueNotification(notification.reportId);
                  }}
                />
              )}
              {notification.status === BenefitReportStatus.Pending && (
                <Banner.Close
                  onClick={() => {
                    dismissNotification(notification.reportId);
                  }}
                />
              )}
            </Banner>
          )
      )}
    </>
  );
};
